import React, { Component } from 'react';
import MenuList from "./MenuList";
import closeIcon from '../../assets/header/close.svg'
import Animate from '../Animate';

class MenuMobile extends Component {
    render () {
        const { t, menuOpen, handleMenuToggle ,language} = this.props;
        return (
            <div className="landing-menu-mobile">
                <div className="landing-menu-mobile-header">
                    <img
                        className="landing-close-mobile"
                        src={closeIcon} alt="logo"
                        onClick={e => handleMenuToggle(e)}
                        onKeyPress={e => handleMenuToggle(e)}
                    />
                </div>
                <Animate type="slide-down">
                    <MenuList t={ t } menuOpen={ menuOpen } handleMenuToggle={ handleMenuToggle } language={language}/>
                </Animate>
            </div>
        )
    }
}

export default MenuMobile;
